import { useEffect, useState } from 'preact/hooks';
import { api } from '../lib/api.js';

/**
 * Tiny GET-and-cache hook. Re-fetches when `path` changes.
 *   const { data, loading, error, refetch } = useApi('/ink-books');
 */
export const useApi = (path) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let cancelled = false;
    if (!path) { setData(null); setLoading(false); setError(null); return; }
    setLoading(true);
    setError(null);
    api.get(path)
      .then((d) => { if (!cancelled) setData(d); })
      .catch((e) => { if (!cancelled) setError(e); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [path, tick]);

  return { data, loading, error, refetch: () => setTick((t) => t + 1) };
};
